import { useCallback } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useSub } from '../../../hooks/subscription/use-sub'
import { useGlobalStore } from '../../../store/global-store'
import type { NotifyGift } from '../../../types/lives/notifies'

const LIVE_GIFTS_SENTS = '/LIVE-GIFTS-SENTS'

export const useUpdateToastSendGlobal = () => {
  const liveId = useGlobalStore(useShallow((state) => state.liveId))
  const liveCountry = useGlobalStore(useShallow((state) => state.liveCountry))

  const { addNotifyGiftToastSend, addNotifyGiftToastEarned } = useGlobalStore(
    useShallow((state) => ({
      addNotifyGiftToastSend: state.addNotifyGiftToastSend,
      addNotifyGiftToastEarned: state.addNotifyGiftToastEarned,
    })),
  )

  const notifies = useCallback(
    (notifyGiftSent: NotifyGift) => {
      const topGlobal = notifyGiftSent?.message?.topGlobal
      const topSameCountry = notifyGiftSent?.message?.topSameCountry
      const topLocal = notifyGiftSent?.message?.topLocal
      const currentLiveId = notifyGiftSent?.liveId

      const id = Date.now()

      if (
        topGlobal?.type === 'send' ||
        topGlobal?.type === 'slot' ||
        topSameCountry?.type === 'send' ||
        topSameCountry?.type === 'slot' ||
        topLocal?.type === 'send'
        || topLocal?.type === 'slot'
      ) {
        if (topGlobal && liveId !== currentLiveId) {
          addNotifyGiftToastSend({ ...notifyGiftSent, id })
        }

        if (topSameCountry && !topGlobal && liveId !== currentLiveId) {
          addNotifyGiftToastSend({ ...notifyGiftSent, id })
        }

        if (
          (topLocal && !topSameCountry && !topGlobal) ||
          currentLiveId === liveId
        ) {
          addNotifyGiftToastSend({ ...notifyGiftSent, id })
        }
      }

      if (
        topGlobal?.type === 'earned' ||
        topSameCountry?.type === 'earned' ||
        topLocal?.type === 'earned'
      ) {
        if (topGlobal) {
          return addNotifyGiftToastEarned({ ...notifyGiftSent, id })
        }

        if (topSameCountry && !topGlobal) {
          return addNotifyGiftToastEarned({ ...notifyGiftSent, id })
        }

        if (topLocal && !topSameCountry && !topGlobal) {
          addNotifyGiftToastEarned({ ...notifyGiftSent, id })
        }
      }
    },
    [liveId, addNotifyGiftToastSend, addNotifyGiftToastEarned],
  )

  useSub<NotifyGift>({
    endpoint: `${LIVE_GIFTS_SENTS}/all`,
    skip: !liveId,
    // onData: notifies,
    onData: notifies,
  })

  useSub<NotifyGift>({
    endpoint: `${LIVE_GIFTS_SENTS}/${liveCountry}`,
    skip: !liveCountry,
    onData: notifies,
  })

  useSub<NotifyGift>({
    endpoint: `${LIVE_GIFTS_SENTS}/${liveId}`,
    skip: !liveId,
    onData: notifies,
  })
}
